import { Component, OnInit } from '@angular/core';
import { LocationManagerService } from '@cakeiteasy/web-utils';
import { DOMAIN_LANGUAGE_CODE_MAP } from '../../../translates/translates.service';
import { TranslatesService } from '../../../translates';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'language-selector-dropdown',
  templateUrl: './language-selector-dropdown.component.html',
  styleUrls: ['./language-selector-dropdown.component.scss']
})
export class LanguageSelectorDropdownComponent implements OnInit {
  public codes = [];
  public activeCode = null;

  constructor(private _translation: TranslatesService,
              private _locationManager: LocationManagerService,
              private _translate: TranslateService) {
  }

  ngOnInit() {
    this.codes.push({
      label: 'languageSelectorDropdown.en',
      value: 'en'
    });

    const domain = this._locationManager.getDomainName();
    this.codes.unshift({
      label: `languageSelectorDropdown.${domain}`,
      value: DOMAIN_LANGUAGE_CODE_MAP[domain]
    });

    this.activeCode = this.codes
      .find((code) => code.value === this._translation.getCurrentLang());
  }

  public changeLanguage(code: string) {
    this.activeCode = this.codes
      .find((c) => c.value === code);
    this._translation.changeLang(code);
  }
}
